// 此文件运行在 Web Worker 环境中，无 DOM、无 Vue、无 window 对象
import reSetData from "@/axios/base";
const requestTimestamps = new Map(); // 存储时间戳的临时变量

async function secureFetch(url, options = {}) {
  const {
    baseURL = '',
    token = '',
    hosId = '',
    firmId = 'siv6k7x1',
    version = '1.3.7',
    clientType = 'A',
    method = 'POST',
    data = null,
    timeout = 50000,
  } = options;
  // 构建请求头（与原 axios 拦截器一致）
  const headers = {
    'Content-Type': 'application/json',
    version,
    firmId,
    clientType,
  };

  if (token) headers['Authorization'] = token;
  if (hosId !== undefined) headers['hosId'] = hosId;
  
  // 对业务数据进行安全封装
  const body = reSetData(data, token);
  // 超时控制器
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);

  try {
    // 拼接完整 URL（避免多余斜杠）
    const fullUrl = baseURL.replace(/\/+$/, '') + '/' + url.replace(/^\/+/, '');
    // 根据多个fullUrl和body.timestamp生成唯一的请求标识，如果和上次的body.timestamp一样，说明是重复请求，中断执行
    // fullUrl有不同的请求地址，body.timestamp有不同的时间戳
    // 根据不同的fullUrl存储不同的body.timestamp，避免不同接口之间的冲突
    const timestamp = body.timestamp;
    
    if (requestTimestamps.has(fullUrl)) {
      if (requestTimestamps.get(fullUrl) === timestamp) {
        // 前端中断执行，返回一个特殊的结果，主线程根据这个结果判断是否继续执行
        return { code: 20000, message: 'DUPLICATE_REQUEST' };
      } else {
        requestTimestamps.set(fullUrl, timestamp);
      }
    } else {
      requestTimestamps.set(fullUrl, timestamp);
    }
    const res = await fetch(fullUrl, {
      method,
      headers,
      body: JSON.stringify(body),
      signal: controller.signal, // 关联超时信号
    });

    clearTimeout(timeoutId); // 成功则清除超时
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  } catch (err) {
    clearTimeout(timeoutId);
    throw err;
  }
}
// 将函数暴露给 Worker 全局作用域
// self.secureFetch = secureFetch;
export default secureFetch;